export default {
  auto: ['actions', 'getters', 'mutations'],

  store: {
    state: {
      pageStatuses: [
        'PENDING',
        'CRAWL_SUCCESS',
        'CRAWL_FAIL',
        'PARSE_SUCCESS',
        'PARSE_FAIL',
        'FILL_SUCCESS',
        'FILL_FAIL',
        'MEDIA_SUCCESS',
        'MEDIA_PROGRESS',
        'MEDIA_FAIL',
      ].map(status => ({ label: status, value: status })),
    },
    getters: {
      pageStatuses: ({ pageStatuses }) => pageStatuses,
    },
  },
}
